import React from 'react'
import styled from 'styled-components'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'

export const Loading = ({ isLoading }) => {
  if (isLoading) {
    return (
      <Overlay>
        <OverlayWrapper>
          <BeatLoader
            css={ css(`
              position: absolute;
              left: 50%;
              top: 50%;
          `) }
            sizeUnit={ "px" }
            size={ 15 }
            color={ '#D44B49' }
            loading={ isLoading }
          />
        </OverlayWrapper>
      </Overlay>
    )
  }
  return null
}

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/components/loading/index.js